import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import styled from "styled-components";
import { HeroGraphics } from "./HeroGraphics";
import { useScrollToSection } from "@utils/hooks";
const HeroSection = styled.header `
  text-align: left;
  position: relative;
  margin-bottom: 32px;
  z-index: 0;
  overflow: visible;
  width: 100%;
`;
const HeroInner = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  min-height: 80vh;
  z-index: 3;
`;
const HeroLeft = styled.div `
  flex: 1 1 55%;
  z-index: 4;
  position: relative;
  padding-right: 24px;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Title = styled.h1 `
  font-size: 3.2rem;
  font-weight: 700;
  margin: 0 0 18px 0;
  line-height: 1.3;

  @media (max-width: 900px) {
    font-size: 2.6rem;
    line-height: 1.1;
  }
`;
const Intro = styled.p `
  font-size: 1.3rem;
  line-height: 1.4;
  margin-bottom: 24px;
  margin-top: 0;

  b {
    font-weight: 600;
  }
`;
const HeroButtons = styled.div `
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`;
const PrimaryButton = styled.button `
  background: #111;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 28px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #ffce3c;
    color: #111;
  }
`;
const SecondaryButton = styled.button `
  background: #fff;
  color: #111;
  border: 1.5px solid #bbb;
  border-radius: 10px;
  padding: 12px 28px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: border 0.2s, background 0.2s;

  &:hover {
    border: 1.5px solid #ffce3c;
    background: #fffae6;
  }
`;
const Hero = () => {
    const scrollToProjects = useScrollToSection(".projects-section");
    useEffect(() => {
        // Initialize parallax effect
        const handleParallax = () => {
            const scrollY = window.scrollY || window.pageYOffset;
            const hero = document.querySelector(".hero");
            if (!hero)
                return;
            const rect = hero.getBoundingClientRect();
            const windowH = window.innerHeight;
            const heroTop = rect.top + scrollY;
            const heroHeight = hero.offsetHeight;
            const progress = Math.min(1, Math.max(0, (scrollY - heroTop + windowH) / (heroHeight + windowH)));
            // Parallax values
            const barY = -60 * progress;
            const pieY = 40 * progress;
            const lineY = 80 * progress;
            document.documentElement.style.setProperty("--parallax-bar", `${barY}px`);
            document.documentElement.style.setProperty("--parallax-pie", `${pieY}px`);
            document.documentElement.style.setProperty("--parallax-line", `${lineY}px`);
        };
        const addParallaxClasses = () => {
            document
                .querySelectorAll(".hero-bar-graph, .hero-pie, .hero-line")
                .forEach((el) => {
                el.classList.add("parallax");
            });
        };
        const handleScroll = () => {
            window.requestAnimationFrame(handleParallax);
        };
        addParallaxClasses();
        handleParallax();
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const handleDownloadResume = () => {
        // Resume PDF can be uploaded to Firebase Storage or served as static file
        // For now, show a message - you can add the PDF URL here later
        console.log("Resume download clicked - PDF URL needed");
        alert("Resume download will be available soon. Contact me for a copy!");
        // Once you upload PDF to Firebase Storage, use this:
        // const resumeUrl = 'YOUR_FIREBASE_STORAGE_URL_HERE';
        // window.open(resumeUrl, '_blank');
    };
    return (_jsxs(HeroSection, { className: "hero", children: [_jsx(HeroGraphics, {}), _jsx(HeroInner, { children: _jsxs(HeroLeft, { children: [_jsx(Title, { children: "Crafting High-Performance Frontends. Delivering Exceptional User Experiences." }), _jsxs(Intro, { children: ["I'm ", _jsx("b", { children: "Raja Kedia" }), ", a Frontend Developer focused on", " ", _jsx("b", { children: "React & React Native" }), ". With a track record of leading high-impact video and ad-tech projects at FanCode and shaping seamless user journeys at Flipkart, I build modern-web and mobile experiences at scale."] }), _jsxs(HeroButtons, { children: [_jsx(PrimaryButton, { onClick: scrollToProjects, children: "View Projects" }), _jsx(SecondaryButton, { onClick: handleDownloadResume, children: "Download Resume" })] })] }) })] }));
};
export default Hero;
